import React from 'react';

function Projects() {
  return (
    <div>
      <hr />
      <p id="spacing">

        <b>MY PORTFOLIO:</b>
        <br />
        SEP. 2024 - NOV. 2024
        <ul>
          <li>Technologies used: ReactJS, HTML5/CSS3, JavaScript</li>
          <li>Developed a personal portfolio website to showcase my skills, profile, and journey as a software developer. The website includes sections detailing my education, projects, achievements, and a contact form. I utilized ReactJS for the frontend, ensuring responsiveness and a smooth user experience across devices. Hosted the website on GitHub Pages for easy access and demonstration of my web development capabilities.</li>
        </ul>
        <br />

        <b>MOVIE RECOMMENDATION SYSTEM USING EDA AND KNN:</b>
        <br />
        JAN. 2024 - APR. 2024
        <ul>
          <li>Technologies used: Python, Pandas, NumPy, Scikit-Learn, Flask, HTML5/CSS3, JavaScript</li>
          <li>Developed a movie recommendation system using EDA, Collaborative Filtering, and KNN, and built a UI/UX interface allowing users to receive personalized movie suggestions.</li>
        </ul>
        <br />

        <b>TRAINING IMAGE CLASSIFIER FOR MNIST DATASET:</b>
        <br />
        MAR. 2024 - APR. 2024
        <ul>
          <li>Technologies used: Python, TensorFlow, Keras, Matplotlib, Seaborn</li>
          <li>Trained image classifiers using MLP and CNN layers on the MNIST dataset, calculating and visualizing training and validation loss to assess model performance.</li>
        </ul>
        <br />

        <b>LOGISTIC REGRESSION AND NAIVE BAYES CLASSIFIER: EFFECTS AND FUNCTIONING:</b>
        <br />
        FEB. 2024 - MAR. 2024
        <ul>
          <li>Technologies used: Python, Scikit-Learn, NumPy, Pandas, Matplotlib, Seaborn</li>
          <li>Implemented and compared Logistic Regression and Naive Bayes classifiers to analyze their functioning, decision boundaries, and feature impact on binary classification problems.</li>
        </ul>
        <br />

        <b>SIMPLE V/S MULTIPLE LINEAR REGRESSION:</b>
        <br />
        JAN. 2024 - FEB. 2024
        <ul>
          <li>Technologies used: Python, NumPy, Pandas, Scikit-Learn, Matplotlib, Seaborn</li>
          <li>Compared MSE loss, calculation methods, and behavioral differences between Simple and Multiple Linear Regression models, including applying Simple Linear Regression to data meant for Multiple Linear Regression.</li>
        </ul>
        <br />

        <b>GAMER'S HUB:</b>
        <br />
        JAN. 2024 - APR. 2024
        <ul>
          <li>Technologies used: HTML5/CSS3, Java, ReactJS, Angular, JavaScript, JDBC, SQL, Neo4j, MongoDB, Servlets, JSP</li>
          <li>Developed a full-stack e-commerce website that offers a wide range of gaming products, including gaming setups. Utilized Java, ReactJS, Angular for responsive and interactive front-end design, HTML5/CSS3 for styling, and a combination of SQL and MongoDB for database management. JDBC was used for database connectivity, while Neo4j managed complex relationships. Server-side logic was implemented using Servlets and JSP.</li>
        </ul>
        <br />

        <b>TASKBLAST:</b>
        <br />
        NOV. 2023 - DEC. 2023
        <ul>
          <li>Technologies used: Flutter, Dart, Git, RestAPI, JSON, Android Studio, VS Code, NoSQL, Git Repository, Java, HTML5/CSS3</li>
          <li>Developed an android application for managing daily tasks, with personalized theme and login credentials for private list access.</li>
        </ul>
        <br />

        <b>BATTLESHIPS:</b>
        <br />
        OCT. 2023 - NOV. 2024
        <ul>
          <li>Technologies used: Flutter, Dart, Git, RestAPI, JSON, Android Studio, VS Code, NoSQL, Git Repository, Java, HTML5/CSS3</li>
          <li>Developed an android application for managing account, games stats, and playing the Battleships game with live players.</li>
        </ul>
        <br />

        <b>LET’S STUDY:</b>
        <br />
        AUG. 2023 - OCT. 2024
        <ul>
          <li>Technologies used: Flutter, Dart, Git, RestAPI, JSON, Android Studio, VS Code, NoSQL, Git Repository, Java, HTML5/CSS3</li>
          <li>Developed an android application for creating and managing decks and flashcards, with individual access to private application screens and cards to study.</li>
        </ul>
        <br />

        <b>PATHQUEST:</b>
        <br />
        MAR. 2023 - APR. 2023
        <ul>
          <li>Technologies used: Python, Pandas, NumPy, Greedy BFS, A* Algorithm, CSV, Matplotlib, Pytest, VS Code, Git</li>
          <li>Developed a Python program to find the shortest path between two places using Greedy BFS and A* algorithms. The project reads path distances from a CSV file using Pandas and visualizes the routes with Matplotlib, with performance and accuracy tested via Pytest.</li>
        </ul>
        <br />

        <b>SUDOKUCRACKER:</b>
        <br />
        JAN. 2023 - FEB. 2023
        <ul>
          <li>Technologies used: Python, NumPy, Backtracking Algorithm, Constraint Propagation, Jupyter Notebook, Git, VS Code, Matplotlib</li>
          <li>Developed a Sudoku solver that uses backtracking and constraint propagation, with a GUI for user input and visualization. Implemented in Python with NumPy for grid management and tested using Pytest in a Jupyter Notebook environment.</li>
        </ul>
        <br />


        <b>SMART BUILDING SYSTEM USING IOT:</b>
        <br />
        AUG. 2018 - JAN. 2019
        <ul>
          <li>Technologies used: C, Arduino IDE, Arduino Uno SMD R3 Board, Java, JDBC, Java Servlets, JavaScript, ReactJS, HTML5/CSS3, NoSQL, MongoDB, Kafka, AWS, RestAPI, Angular</li>
          <li>Developed a server model system with smart plant irrigation, automatic overhead water tank filling, smart room temperature detection, smart motion detector, IR radiation fire detection with overflow/underflow notifications, along with an e-commerce website selling items required for a Smart Home, other than the pre-installed system.</li>
        </ul>
        <br />

        <b>BLOOD BANK MANAGEMENT SYSTEM USING CLOUD COMPUTING:</b>
        <br />
        JUN. 2017 - DEC. 2017
        <ul>
          <li>Technologies used: HTML5/CSS3, Java, ReactJS, JDBC, Google App Engine, Eclipse IDE, NoSQL, MongoDB, MySQL, GCP, Java EE, RestAPI, Spring Framework</li>
          <li>Developed a full-stack web server application system that contained different modules to avail records for blood and donors, especially during emergencies, using ReactJS and Angular for the main theme pages and HTML5/CSS3 to display data from database, fetched using MySQL, NoSQL, and MongoDB, connected using JDBC.</li>
          <li>Website: <a href="https://bloodbank-198712.appspot.com/">https://bloodbank-198712.appspot.com/</a></li>
        </ul>
        <br />

        <b>FASHIONISTA:</b>
        <br />
        FEB. 2017 - APR. 2017
        <ul>
          <li>Technologies used: HTML5/CSS3, Java, ReactJS, JDBC, Google App Engine, GCP, Eclipse IDE, MongoDB, NoSQL, Neo4J, RestAPI, Java EE, Spring Framework</li>
          <li>Developed a full-stack newsletter server website that contained modules to express vogue fashion trends and provide fashion tips for premium users, using ReactJS and Angular for the main theme pages and HTML5/CSS3 to display data from database, fetched using MySQL, NoSQL, and MongoDB, connected using JDBC.</li>
        </ul>

      </p>
    </div>
  );
}

export default Projects;